
import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
} from '../../services/AuthService';


export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const NAVTOGGLE = 'NAVTOGGLE';

export function Logout(navigate) {
    return (dispatch) => {
        // Clear all localStorage items
        localStorage.removeItem('userDetails');
        localStorage.removeItem('token');

        // Clear redux-persist storage
        localStorage.removeItem('persist:auth');
        localStorage.removeItem('persist:root');

        // Clear sessionStorage as well
        sessionStorage.clear();

        // Dispatch logout action to clear Redux state
        dispatch({
            type: LOGOUT_ACTION,
        });

        // Navigate to login after a short delay to ensure state is cleared
        setTimeout(() => {
            navigate('/login');
        }, 100);
    };
}

export function loginAction(email, password, navigate) {
    return (dispatch) => {
        login(email, password)
            .then((response) => {
                const userData = {
                    token: response.data.data.token,
                    email: email,
                    name: response.data.data.name || '',
                    phone: response.data.data.phone || '',
                    status: response.data.data.status || '',
                    roleDetails: response?.data?.data?.roleDetails || '',
                };
                saveTokenInLocalStorage(userData);
                dispatch(loginConfirmedAction(userData));
            })
            .catch((error) => {
                const errorMessage = formatError(error.response);
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}



export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export const navtoggle = () => {
    return {
        type: 'NAVTOGGLE',
    };
};